var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadLogoCubase = function SvgFadLogoCubase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.446 127.855 140.401 46.3l32.106 26.083s-11.13.225-20.794 3.706c-9.663 3.48-14.486 8.596-19.58 14.04-11.146 11.915-14.325 23.365-14.243 37.955.08 14.59 4.462 22.448 12.94 33.133 2.87 3.619 5.696 7.099 10.508 9.728 1.64.897 8.563 5.947 13.122 7.36 4.559 1.413 16.789 1.949 16.789 1.949l-29.911 31.06-82.892-83.459z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 126,
    r: 22
  }))));
};
export { SvgFadLogoCubase as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-logo-cubase.3a359940.svg";